import React, {useEffect, useRef, useState} from 'react';
import {Alert, Button, Card, Col, Input, Row, Space, Statistic, Table, Typography} from 'antd';
import {QRCodeCanvas} from 'qrcode.react';
import {useNavigate} from 'react-router-dom';
import api from '../utils/api';

const {Title, Text} = Typography;

const PartnerReferralsPage = () => {
  const [summary, setSummary] = useState({});
  const [link, setLink] = useState({});
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [query, setQuery] = useState('');
  const qrRef = useRef();
  const navigate = useNavigate();

  const load = async (q = '') => {
    setLoading(true); setError(null); setPatients([]);
    try {
      const [summaryResult, linkResult, patientsResult] = await Promise.all([
        api.get('/v1/partner/referrals/summary'),
        api.get('/v1/partner/referrals/link'),
        api.get('/v1/partner/referrals/patients', {params: {q}}),
      ]);
      setSummary(summaryResult.data); setLink(linkResult.data); setPatients(patientsResult.data.patients || []);
    } catch (requestError) {
      setPatients([]);
      setError(requestError.response?.status === 403 ? 'Referral access is unavailable or has been revoked.' : 'Could not load referral data.');
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);
  const downloadQr = () => {
    const canvas = qrRef.current?.querySelector('canvas');
    if (!canvas) return;
    const anchor = document.createElement('a'); anchor.download = 'glacies-referral-qr.png'; anchor.href = canvas.toDataURL('image/png'); anchor.click();
  };

  return <div className="cardContainer" style={{margin: 24, padding: 24}}>
    <Title level={2}>B2C referrals</Title>
    {error && <Alert type="error" showIcon message={error} style={{marginBottom: 16}}/>}
    <Row gutter={16}>{['opens','registration_started','verified','completed'].map(key =>
      <Col xs={12} md={6} key={key}><Card><Statistic title={key.replaceAll('_',' ')} value={summary[key] || 0}/></Card></Col>)}</Row>
    <Card title="Partner link" style={{marginTop: 16}}>
      {link.referral_enabled && link.branch_url ? <Space align="start" wrap>
        <div ref={qrRef}><QRCodeCanvas value={link.branch_url} size={144}/></div>
        <Space direction="vertical"><Text copyable>{link.branch_url}</Text><Text>Partner code: <b>{link.partner_code}</b></Text><Button onClick={downloadQr}>Download QR</Button></Space>
      </Space> : <Alert type="warning" message="Referrals are not enabled for this Organization."/>}
    </Card>
    <Card title="Referred patients" style={{marginTop: 16}} extra={<Input.Search value={query} onChange={e => setQuery(e.target.value)} onSearch={load} placeholder="Search patients"/>}>
      <Table loading={loading} dataSource={patients} rowKey="id" onRow={record => ({onClick: () => navigate(`/patient-cabinet/${record.id}`), style: {cursor: 'pointer'}})} columns={[
        {title:'Patient', render:(_,p)=>`${p.first_name} ${p.last_name}`},
        {title:'Email', dataIndex:'email'}, {title:'Joined', dataIndex:'verified_at'},
        {title:'Access', dataIndex:'access_status'},
      ]}/>
    </Card>
  </div>;
};

export default PartnerReferralsPage;
